import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      minHeight: 200,

      padding: SPACES.xxl,
      maxHeight: 'calc(100vh - 100px)',

      outline: 'none',

      [theme.breakpoints.down('tablet')]: {
        minWidth: 320,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 600,
      },
    },
  },
  titleWrapper: {
    marginBottom: SPACES.xxxxl,

    display: 'flex',
    alignItems: 'flex-start',
    gap: SPACES.xl,
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  modalTitle: {
    '&&': {
      margin: 0,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },
  buttonsGroup: {
    '&&': {
      marginRight: 30,

      maxHeight: 40,
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.s,
  },
  noneWrapper: {},
  qrCodeReqWrapper: {
    marginBottom: SPACES.xxxl,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: SPACES.s,
  },

  tabContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'overlay' as any,

    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.palette.custom.grey2} ${theme.palette.custom.grey2}`,
    '&::-webkit-scrollbar': {
      width: '3px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.custom.grey2,
      borderRadius: '10px',
    },
  },
  tabWrapper: {
    width: '100%',
  },
  divider: {
    '&&': {
      marginTop: SPACES.xxl,
      marginBottom: SPACES.xxl,
    },
  },
  section: {},
  stepText: {
    margin: 0,
    color: theme.palette.custom.grey2,
    fontSize: FONTS.SIZES.m,
  },
  sectionTitle: {
    margin: 0,
    marginBottom: SPACES.s,
    color: theme.palette.custom.darkBlue2,
    fontSize: FONTS.SIZES.xl,
  },
  sectionText: {
    margin: 0,
    color: theme.palette.custom.darkBlue2,
    fontSize: FONTS.SIZES.m,
  },
  qrCodeSection: {
    display: 'flex',
    gap: SPACES.s,
  },
  qrCodeWrapper: {
    marginRight: 20,
  },
  totpVerifyForm: {
    marginTop: SPACES.xxl,

    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.m,
  },
  userEmail: {
    fontWeight: FONTS.WEIGHTS.bold,
    color: theme.palette.custom.black,
  },
  codeButton: {
    '&&': {
      marginTop: SPACES.s,
    },
  },
  returnBackButton: {
    '&&': {
      marginBottom: SPACES.m,
    },
  },
  disableUpperWrapper: {
    marginBottom: SPACES.xl,
  },
}))
